exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".free-shield-a{fill:#10b981}.free-shield-b{fill:#fff}", ""]);

// exports
